import http from '@core/fetch'

export default {
  record_list: () => http('/p/wedding/Admin/APIMerchantPrivilege/record_list'),

  current_list: body =>
    http('/p/wedding/Admin/APIMerchantPrivilege/current_list', { body }),

  edit: body =>
    http.post('/p/wedding/Admin/APIMerchantPrivilege/edit', { body }),

  add: body => http.post('/p/wedding/Admin/APIMerchantPrivilege/add', { body }),

  market: () => http('/p/wedding/index.php/admin/APISetMeal/market'),

  tag: body => http.post('/p/wedding/index.php/admin/APISetMeal/tag', { body }),

  tag_list: body =>
    http('/p/wedding/index.php/admin/APISetMeal/setmeal_list', { body })
}
